<template>
  <div class="rbu-item-fluctuations">
    <RbuFluctuation
      v-for="(fluctuation, fluctuationIdx) in fluctuations"
      :key="fluctuationIdx"
      :fluctuation="fluctuation"
      :idx="fluctuationIdx"
      @update="onFluctuationUpdate(fluctuationIdx, $event)"
      @delete="onFluctuationDelete(fluctuationIdx)"
    ></RbuFluctuation>
  </div>
</template>

<script>
import RbuFluctuation from "@/components/rbu/RbuFluctuation.vue";
import { computed, inject } from "@vue/composition-api";

export default {
  name: "RbuItemFluctuations",
  components: { RbuFluctuation },
  props: {
    fluctuations: Array,
  },
  setup(props, { root, emit }) {
    const onFluctuationUpdate = function (idx, evt) {
      let dataPoints = _.concat(props.fluctuations || [], []);
      dataPoints.splice(idx, 1, {
        ...props.fluctuations[idx],
        ...evt,
      });

      emit("input", dataPoints);
    };

    const onFluctuationDelete = function (idx) {
      let dataPoints = _.concat(props.fluctuations || [], []);
      dataPoints.splice(idx, 1);
      emit("input", dataPoints);
    };

    return {
      onFluctuationUpdate,
      onFluctuationDelete,
    };
  },
};
</script>

<style lang="less">
.rbu-item-fluctuations {
  display: contents;
}
</style>
